const iconsList = {
    map: "map",
    digitalCuratorship: "digitalCuratorship",
    chat: "chat",
    user: "user",
    back: "back",
    location: "location",
    albert: "albert",
    championships: "championships",
    chatAi: "chatAi",
    curatorship: "curatorship",
    games: "games",
    magicSchool: "magicSchool",
    profile: "profile",
    close: "close",
    eye: "eye",
    like: "like",
    accessibility: "accessibility",
    settings: "settings",
    arrow: "arrow",
    refresh: "refresh",
    check: "check",
    filter: "filter"
}
export default iconsList
